import FormattedMessage from 'I18n/components/FormattedMessage';
import { ArtificialIntelligenceEnhancedIcon, CtasIcon, DataSyncIcon, RefreshIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardHeader, CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { useIsMobile } from 'pricing-pages-lib/context/IsMobileContext';
import { PageSection, SectionHeader, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { LEARN_ABOUT_HUBSPOT_CREDITS } from '../../constants/tracking/TrackingSources';
import ProductAndServicesCatalogLink from '../ProductAndServicesCatalogLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CardLayout = ({
  title,
  description,
  icon
}) => {
  return /*#__PURE__*/_jsxs(CardWrapper, {
    position: "relative",
    children: [/*#__PURE__*/_jsx(CardHeader, {
      padding: "600",
      title: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "100",
        children: [/*#__PURE__*/_jsx(IconHolder, {
          icon: icon,
          padding: "0",
          color: "temp-do-not-use-icon-primary-default",
          size: "600"
        }), /*#__PURE__*/_jsx(Text, {
          typography: "heading-100",
          as: "div",
          children: title
        })]
      }),
      titleTagName: "h3"
    }), /*#__PURE__*/_jsx(CardSection, {
      padding: "600",
      paddingBlockStart: "0 !important",
      children: description
    })]
  });
};
const LearnAboutCreditsSection = ({
  title
}) => {
  const isMobile = useIsMobile();
  return /*#__PURE__*/_jsxs(PageSection, {
    children: [/*#__PURE__*/_jsx(SectionHeader, {
      children: /*#__PURE__*/_jsx(SectionTitle, {
        children: title || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.hubspot-credits.learn.header.default"
        })
      })
    }), /*#__PURE__*/_jsx(CardLayout, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.hubspot-credits.learn.cards.whatAreHubSpotCredits.title"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.hubspot-credits.learn.cards.whatAreHubSpotCredits.description"
      }),
      icon: ArtificialIntelligenceEnhancedIcon
    }), /*#__PURE__*/_jsxs(CardGrid, {
      columns: isMobile ? 1 : 3,
      columnGap: "600",
      marginBlock: "600",
      children: [/*#__PURE__*/_jsx(CardLayout, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.hubspot-credits.learn.cards.creditsAreFlexible.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.hubspot-credits.learn.cards.creditsAreFlexible.description"
        }),
        icon: DataSyncIcon
      }), /*#__PURE__*/_jsx(CardLayout, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.hubspot-credits.learn.cards.creditsResetMonthly.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.hubspot-credits.learn.cards.creditsResetMonthly.description"
        }),
        icon: RefreshIcon
      }), /*#__PURE__*/_jsx(CardLayout, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.hubspot-credits.learn.cards.estimateCreditUsage.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.hubspot-credits.learn.cards.estimateCreditUsage.description"
        }),
        icon: CtasIcon
      })]
    }), /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(ProductAndServicesCatalogLink, {
        trackingSource: LEARN_ABOUT_HUBSPOT_CREDITS,
        section: "#HubSpotCreditsRateSheet",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.hubspot-credits.links.viewCreditsRateSheet"
        })
      })
    })]
  });
};
export default LearnAboutCreditsSection;